import { render, staticRenderFns } from "./PersistResponsavelGrupoParceiroView.vue?vue&type=template&id=5adf174a&"
import script from "./PersistResponsavelGrupoParceiroView.vue?vue&type=script&lang=ts&"
export * from "./PersistResponsavelGrupoParceiroView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports